const ComponentBase = require('../../base/ComponentBase');
const ScaleUtil = require('./utils/ScaleUtil');
/**
 * @constructor
 * @classdesc 专题图组件
 * @augments G.base.ComponentBase
 * @alias G.common.ThematicMap
 * @param {Object} options
 * @param {G.Map} options.map 地图对象
 */
let component = ComponentBase.extend({
    options: {
        scaleMaxWidth: 100
    },
    initialize(options) {
        ComponentBase.prototype.initialize.call(this, options);
        //
    },

    /**
     * @inheritdoc
     */
    addListeners() {
        this.map.listen("resolutionchanged", this._resolutionchanged, this);
    },

    /**
     * @inheritdoc
     */
    removeListeners() {
        this.map.off("resolutionchanged", this._resolutionchanged);
    },

    /**
     * 获取地图dom对象
     * @method
     * @memberof G.common.ThematicMap.prototype
     */
    getMapDom() {
        let containerId = this.map.options.targetId;
        return document.getElementById(containerId);
    },


    /**
     * 获取比例尺
     * @method
     * @memberof G.common.ThematicMap.prototype
     */
    getScale() {
        let scaleData = ScaleUtil.getScale(this.map, {
            scaleMaxWidth: this.options.scaleMaxWidth
        });
        return scaleData;
    },

    /**
     * 导出专题图
     * @method
     * @memberof G.common.ThematicMap.prototype
     * @param {Object} opts 
     * @param {String} opts.domId 专题图容器ID
     */
    export (opts) {
        return new Promise((resolve, reject) => {
            resolve({});
        });
    },

    /**
     * 下载专题图
     * @method
     * @memberof G.common.ThematicMap.prototype
     * @param {Object} opts 
     * @param {String} opts.domId 专题图容器ID
     * @param {String} opts.name 文件名称
     */
    download(opts) {
        let screenShot = new G.common.ScreenShot({
            map: this.map
        });
        screenShot.downloadImage(opts.domId, opts.name);
        screenShot.destroy;
    },

    /**
     * 设置地图容器尺寸
     * @method
     * @memberof G.common.ThematicMap.prototype
     * @param {Number} [width]  像素宽
     * @param {Number} [height]  像素高
     */
    updateMapViewSize(width, height) {
        let dom = this.getMapDom();
        if (!isNaN(width)) {
            dom.style.width = width + 'px';
        }
        if (!isNaN(height)) {
            dom.style.height = height + 'px';
        }
        this.map.updateViewSize();
    },


    //
    _resolutionchanged() {
        this._updateScale();
    },

    //更新比例尺
    _updateScale() {
        let scaleData = ScaleUtil.getScale(this.map, {
            scaleMaxWidth: this.options.scaleMaxWidth
        });
        if (scaleData) {
            this.fire('update-scale', scaleData);
        }
    },

    /**
     * @inheritdoc
     */
    destroy() {
        ComponentBase.prototype.destroy.call(this);
    }
});
module.exports = component;